import React, { useState, useEffect } from "react";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { LocalizationProvider, MobileDateTimePicker, DateTimeField } from '@mui/x-date-pickers';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EquipmentSuggestions from "./EquipmentSuggestions";

import currentUserToken from "CurrentUserToken";
import { get } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";

function AlarmStep(props) {
  const [showEquipmentSuggestion, setShowEquipmentSuggestion] = useState(false);
  const [equipmentData, setEquipmentData] = useState({
    audit: [],
    fetched: false,
  });

  useEffect(() => {
    const tlmGetAccountEquipments = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/accountNumber/equipment/get",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {
              account_number: props.mainFormData.account_number,
            },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        if (Array.isArray(response)) {
          response.forEach((element) => {
            if (typeof element.timestamp === "number") {
              element.timestamp = dayjs(element.timestamp).format(
                "YYYY-MM-DD HH:mm"
              );
            }
          });
          setEquipmentData({ audit: response, fetched: true });
        }
      } catch (error) {
        console.error("Errore durante la chiamata API:", error);
      }
    };

    tlmGetAccountEquipments();
  }, []);

  const handleChange = (event) => {
    props.handleMainFormData(event.target.name, event.target.value);
  };

  return (
    <DialogContent>
      <FormControl fullWidth margin="normal" className="custom-form-control">
        <TextField
          label={I18n.get("Account Number")}
          value={props.mainFormData.account_number}
          fullWidth
          margin="normal"
          name="account_number"
          InputProps={{
            readOnly: true,
          }}
          required
          disabled
          className="custom-text-field"
        />
        <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
      </FormControl>

      <FormControl fullWidth margin="normal" className="custom-form-control">
        <TextField
          label={I18n.get("Alarm Text")}
          value={props.mainFormData.original_message}
          onChange={handleChange}
          fullWidth
          margin="normal"
          name="original_message"
          required
          className="custom-text-field"
        />
        <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
      </FormControl>

      <FormControl fullWidth margin="normal" className="custom-form-control">
  <InputLabel>{I18n.get("Priority")}</InputLabel>
  <Select
    value={props.mainFormData.original_priority || ""}
    onChange={handleChange}
    name="original_priority"
    label={I18n.get("Priority")}
  >
  {/* Add an empty MenuItem to allow clearing the selection */}
  <MenuItem value="" style={{ minHeight: "48px" }}>
      <em></em>
    </MenuItem>
    {[...Array(4).keys()].map((number) => (
      <MenuItem key={number + 1} value={number + 1}>
        {number + 1}
      </MenuItem>
    ))}
  </Select>
</FormControl>


      <FormControl fullWidth margin="normal" className="custom-form-control">
        <TextField
          label={I18n.get("Original Equipment")}
          value={props.mainFormData.original_equipment || ""}
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
          name="original_equipment"
          // InputProps={{
          //   endAdornment: (
          //     <InputAdornment position="end">
          //       <SettingsSuggestIcon
          //         style={{ cursor: "pointer" }}
          //         onClick={() => setShowEquipmentSuggestion(true)}
          //       />
          //     </InputAdornment>
          //   ),
          // }}
        />
        <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
      </FormControl>

      <FormControl fullWidth margin="normal" className="custom-form-control">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimeField
            label={I18n.get("End Date")}
            format="YYYY/MM/DD HH:mm"
            value={props.mainFormData.datetime_end ? dayjs(props.mainFormData.datetime_end) : null}
            onChange={(newDate) => {
              const formattedDate = dayjs(newDate).format("YYYY-MM-DD HH:mm:ss");
              props.handleMainFormData("datetime_end", formattedDate);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                variant="outlined"
                InputProps={{
                  style: {
                    padding: "4px",
                    fontSize: "14px",
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      </FormControl>

      <FormControl fullWidth margin="normal" className="custom-form-control">
        <TextField
          label={I18n.get("Position")}
          value={props.mainFormData.position || ""}
          onChange={handleChange}
          fullWidth
          margin="normal"
          name="position"
        />
      </FormControl>

      <EquipmentSuggestions
        open={showEquipmentSuggestion}
        state={equipmentData}
        onClose={() => setShowEquipmentSuggestion(false)}
        setEquipment={(equipment) =>
          props.handleMainFormData("original_equipment", equipment)
        }
      />
    </DialogContent>
  );
}

export default AlarmStep;
